<template>
    <div class="d-flex align-items-center w-100">
        <div v-if="sign_status === 'SIGNED'" class="mr-2">
            <img src="/static/images/icons/reservation/signed_bg_24.svg" title="Signed rental agreement" />
        </div>
        <div v-else-if="sign_status === 'PENDING'" class="mr-2">
            <img
                src="/static/images/icons/reservation/sign_pending_bg_24.svg"
                title="Rental agreement pending signature"
            />
        </div>
        <div v-else-if="sign_status === 'UNSIGNED'" class="mr-2">
            <img src="/static/images/icons/reservation/unsigned_bg_24.svg" title="Rental agreement not signed" />
        </div>
        <span v-else></span>
        <reservation-verification-status-icon :status="verification_status" />

        <div v-if="has_services" class="mr-2">
            <img src="/static/images/icons/reservation/bell_bg_24.svg" title="Optional services" />
        </div>
        <img
            class="mr-2"
            v-if="has_travel_insurance"
            src="/static/images/icons/reservation/insurance_bg_24.svg"
            title="Travel Insurance"
        />
        <img
            v-if="has_pets"
            src="/static/images/icons/reservation/pets_bg_24.svg"
            title="Guest has indicated they will be bringing a pet"
        />
        <img v-if="allow_sms"
             width="20"
             height="20"
             title="SMS"
             src="/static/images/icons/reservation/sms_optin_bg_24.svg"
        />
    </div>
</template>

<script>
import ReservationVerificationStatusIcon from '../../common/reservation-verification-status-icon.vue';
export default {
    components: { ReservationVerificationStatusIcon },
    data() {
        return {
            status: null,
            sign_status: null,
            has_travel_insurance: null,
            has_pets: null,
            has_services: null,
            verification_status: null,
            allow_sms: null,
        };
    },
    mounted() {
        this.sign_status = this.params.data.sign_status;
        this.has_travel_insurance = this.params.data.has_travel_insurance;
        this.has_pets = this.params.data.has_pets;
        this.has_services = this.params.data.has_services;
        this.verification_status = this.params.data.verification_status;
        this.allow_sms = this.params.data.allow_sms;
    },
};
</script>